import * as yup from 'yup'

export const CoverModalSchema = yup.object({
  carrierApplicationId: yup.string().required('Carrier must be selected'),
  carrierContactId: yup.string(),
  bookingContactName: yup.string().required('Booking Contact Name required'),
  bookingContactEmail: yup.string(),
  bookingContactPhone: yup.string().matches(/.{10,}/, 'Phone number is invalid'),
  bookingContactPhoneExt: yup.string(),
  rate: yup.number().nullable().typeError('Rate amount required').required('Rate amount required'),
  // Call Now
  assignDriverTime: yup
    .string()
    .nullable()
    .when('carrierApplicationId', {
      is: value => !!value,
      then: (schema: yup.StringSchema) =>
        schema.required('Select an opton for assigning driver').nullable(false),
    }),
  truckNumber: yup.string(),
  trailerNumber: yup.string(),
  vinNumber: yup.string(),
  driverId: yup
    .string()
    .nullable(true)
    .when('assignDriverTime', {
      is: value => value === 'now',
      then: (schema: yup.ObjectSchema) => schema.required('Driver required'),
    }),
  driverContactPhone: yup.string().when('assignDriverTime', {
    is: value => value === 'now',
    then: (schema: yup.StringSchema) => schema.required('Driver Contact Number required'),
  }),
  etaDriverLocation: yup
    .object({ location: yup.object({ city: yup.string(), state: yup.string() }) })
    .nullable()
    .when('assignDriverTime', {
      is: value => value === 'now',
      then: yup
        .object({ location: yup.object({ city: yup.string(), state: yup.string() }) })
        .nullable()
        .required('Empty Driver Location required'),
    }),
  etaDate: yup
    .date()
    .nullable()
    .when('assignDriverTime', {
      is: value => value === 'now',
      then: (schema: yup.StringSchema) => schema.required('ETA Date required').nullable(false),
    }),
  etaTime: yup
    .string()
    .nullable()
    .when('assignDriverTime', {
      is: value => value === 'now',
      then: (schema: yup.StringSchema) => schema.required('ETA Time required').nullable(false),
    }),
  // Call Back
  useCustomCallback: yup
    .string()
    .nullable()
    .when('assignDriverTime', {
      is: value => value === 'later',
      then: (schema: yup.StringSchema) =>
        schema.required('Select an option for callback').nullable(false),
    }),
  callbackDate: yup
    .date()
    .nullable()
    .when('useCustomCallback', {
      is: value => value === 'yes',
      then: (schema: yup.StringSchema) => schema.required('Callback Date required').nullable(false),
    }),
  callbackTime: yup
    .string()
    .nullable()
    .when('useCustomCallback', {
      is: value => value === 'yes',
      then: (schema: yup.StringSchema) => schema.required('Callback Time required').nullable(false),
    }),
  lateReason: yup
    .string()
    .nullable()
    .when('$exist', {
      is: exist => exist,
      then: yup.string().required('Late Reason required').nullable(false),
      otherwise: yup.string(),
    }),
  trackingRequired: yup
    .boolean()
    .required('Acknowledge tracking through app has been conveyed to dispatcher')
    .nullable(false)
    .oneOf([true], 'Acknowledge tracking through app has been conveyed to dispatcher'),
  additionalCarrierInfo: yup.string().nullable(true),
})

export type TCoverModalSchema = yup.InferType<typeof CoverModalSchema>
